import { useParams, useSearchParams } from "react-router-dom";
import ProductFormSkeleton from "@/app/components/common/skeletons/ProductFormSkeleton";
import { useGetCategoriesQuery, useGetProductQuery } from "@/lib/api/apiSlice";
import { useShowInitialLoader } from "@/lib/hooks";
import ProductForm from "@/app/components/seller/product/ProductForm";

const categoryRelations = [
  "subCategories",
  "subCategories.subSubCategories",
  "subCategories.subSubCategories.categoryAttributes",
  "subCategories.subSubCategories.categoryAttributes.attribute",
  "subCategories.subSubCategories.categoryAttributes.attribute.attributeDetails",
].join(",");

export default function EditProductPage() {
  const params = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const id = params.id ?? searchParams.get("id") ?? undefined;

  const { data: categories, isLoading: isCategoriesLoading } =
    useGetCategoriesQuery({ relations: categoryRelations });
  const { data: product, isLoading: isProductLoading } = useGetProductQuery(
    id!,
    { skip: !id },
  );

  const showCategoriesLoader = useShowInitialLoader(
    isCategoriesLoading,
    categories,
  );
  const showProductLoader = useShowInitialLoader(isProductLoading, product);

  if (!id) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <p className="text-lg">Product not found.</p>
      </div>
    );
  }

  if (showCategoriesLoader || showProductLoader) {
    return <ProductFormSkeleton />;
  }

  return (
    <ProductForm
      categories={categories ?? []}
      selectedProduct={product ?? null}
    />
  );
}
